import { render, staticRenderFns } from "./formSetting.vue?vue&type=template&id=6da1692e&scoped=true"
import script from "./formSetting.vue?vue&type=script&lang=js"
export * from "./formSetting.vue?vue&type=script&lang=js"
import style0 from "./formSetting.vue?vue&type=style&index=0&id=6da1692e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1692e",
  null
  
)

export default component.exports